export default __webpack_public_path__ + "static/media/2376.54b9e512.png";